import { Alert } from '@creditornot/cb-alert';
import { Button } from '@creditornot/cb-button';
import { Modal } from '@creditornot/cbt-modal';
import React, { useState } from 'react';
import { useForm } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { DataOptionsDetails } from './DataOptionsDetails';
import { DataOptionsModalContentForm } from './DataOptionsModalContentForm';
import ReportFormItem from '../../core/ReportFormItem';
import { InsightReportForm, ReportDataOption } from '../../types';

type DataOptionsFormItemProps = {
  dataOptions: ReportDataOption[];
};

export const DataOptionsFormItem = ({ dataOptions }: DataOptionsFormItemProps) => {
  const [isDataOptionsModalOpen, setIsDataOptionsModalOpen] = useState(false);
  const { formatMessage } = useIntl();
  const form = useForm<InsightReportForm>();
  const formState = form.getState();
  const formValues = formState.values;

  const handleUpdate = (values: InsightReportForm) => {
    form.change('dataOptions', values.dataOptions);
    handleClose();
  };

  const handleClose = () => {
    setIsDataOptionsModalOpen(false);
  };

  return (
    <>
      <ReportFormItem
        action={
          <Button variant="lightBlue" size="small" onClick={() => setIsDataOptionsModalOpen(true)}>
            <FormattedMessage id="insights.reports.data-options.action" />
          </Button>
        }
        title={<FormattedMessage id="insights.reports.data-options.question" />}
        value={
          <>
            <DataOptionsDetails dataOptions={dataOptions} selectedDataOptions={formValues.dataOptions ?? []} />
            {formState.submitFailed && formState.errors?.dataOptions && (
              <Alert variant="error" size="small">
                {formatMessage({ id: formState.errors.dataOptions.id })}
              </Alert>
            )}
          </>
        }
      />
      <Modal open={isDataOptionsModalOpen} onDismiss={handleClose} disableContentPadding sizePreset="centered:large">
        <DataOptionsModalContentForm
          dataOptions={dataOptions}
          onUpdate={handleUpdate}
          onClose={handleClose}
          selectedDataOptions={formValues.dataOptions ?? []}
        />
      </Modal>
    </>
  );
};
